export default "__VITE_ASSET__OuFAd3S1__"